/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Resources_Compare_Cost_ExcelInputs */

const en_gc_resources_compare_cost_excel = /** @type {(inputs: Gc_Resources_Compare_Cost_ExcelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free web option; paid desktop options`)
};

const zh_gc_resources_compare_cost_excel = /** @type {(inputs: Gc_Resources_Compare_Cost_ExcelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`提供免费网页版本；桌面版有付费选项`)
};

/**
* | output |
* | --- |
* | "Free web option; paid desktop options" |
*
* @param {Gc_Resources_Compare_Cost_ExcelInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_resources_compare_cost_excel = /** @type {((inputs?: Gc_Resources_Compare_Cost_ExcelInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Resources_Compare_Cost_ExcelInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_resources_compare_cost_excel(inputs)
	return zh_gc_resources_compare_cost_excel(inputs)
});
export { gc_resources_compare_cost_excel as "gc.resources.compare.cost.excel" }